import { render } from "./ShareProfileModalComponent.vue?vue&type=template&id=0764d70d&ts=true"
import script from "./ShareProfileModalComponent.vue?vue&type=script&lang=ts"
export * from "./ShareProfileModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__